var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"name":"loading"}},[_c('b-progress',{directives:[{name:"show",rawName:"v-show",value:(_vm.innateLoading),expression:"innateLoading"}],staticClass:"loading-bar",attrs:{"value":_vm.loadingPercentage,"variant":_vm.variant,"max":100,"animated":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }